module.exports = __webpack_public_path__ + "img/round-bg-close-light.8490f86e.png";